import request from '../util/request'

// 登录
export function login(data) {
  return request({
    url: '/api-clarins/account/login',
    method: 'post',
    data: data
  })
}

// 活动列表
export function activityList(data) {
  return request({
    url: '/api-clarins/activity/all',
    method: 'post',
    data: data
  })
}

// 商品列表
export function productList(data) {
  return request({
    url: '/api-clarins/product/all',
    method: 'post',
    data: data
  })
}

// 商品明细
export function productInfo(data) {
  return request({
    url: '/api-clarins/product/info',
    method: 'post',
    data: data
  })
}

// 账户信息
export function accountInfo(data) {
  return request({
    url: '/api-clarins/account/info',
    method: 'post',
    data: data
  })
}

// 保存账户信息
export function saveAccount(data) {
  return request({
    url: '/api-clarins/account/modify',
    method: 'put',
    data: data
  })
}

// 订单列表
export function orderList(data) {
  return request({
    url: '/api-clarins/order/all',
    method: 'post',
    data: data
  })
}

// 产品类型
export function productCategory(data) {
  return request({
    url: '/api-clarins/product/category',
    method: 'get',
    params: data
  })
}

// 保存购物车
export function saveCarInfo(data) {
  return request({
    url: '/api-clarins/cart/add',
    method: 'put',
    data: data
  })
}

// 修改购物车
export function modifyCar(data) {
  return request({
    url: '/api-clarins/cart/modify',
    method: 'put',
    data: data
  })
}


export function delCar(data) {
  return request({
    url: '/api-clarins/cart/remove',
    method: 'put',
    data: data
  })
}

export function clearCar(data) {
  return request({
    url: '/api-clarins/cart/clear',
    method: 'put',
    data: data
  })
}

// 购物车
export function carInfo(data) {
  return request({
    url: '/api-clarins/cart/all',
    method: 'post',
    data: data
  })
}

// 订单列表
export function orderCheck(data) {
  return request({
    url: '/api-clarins/order/check',
    method: 'post',
    data: data
  })
}

export function orderAdd(data) {
  return request({
    url: '/api-clarins/order/add',
    method: 'put',
    data: data
  })
}


export function orderInfo(data) {
  return request({
    url: '/api-clarins/order/info',
    method: 'post',
    data: data
  })
}


export function getImage(data) {
  return request({
    url: '/api-clarins/common/image/url',
    method: 'get',
    params: data
  })
}

export function forgetP(data) {
  return request({
    url: '/api-clarins/account/forget',
    method: 'post',
    data: data
  })
}

export function getPassword(data) {
  return request({
    url: '/api-clarins/account/password',
    method: 'put',
    data: data
  })
}

export function carMoney(data) {
  return request({
    url: '/api-clarins/cart/amount',
    method: 'post',
    data: data
  })
}